import { Button, Center, Text, VStack } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

export const EmptyCard: React.FC<{
  title: string;
  subtitle?: string;
  buttonText?: string;
  onClick?: () => Promise<void>;
  navTo?: string;
}> = ({ title, subtitle, buttonText, onClick, navTo }) => {
  return (
    <Card w="full">
      <Center h={96}>
        <VStack>
          <Text textStyle="bodyStrong" color="textSecondary.500">
            {title}
          </Text>
          {!!subtitle && <Text color="textSecondary.500">{subtitle}</Text>}
          {!!buttonText && onClick && (
            <Button onClick={onClick}>{buttonText}</Button>
          )}
          {!!buttonText && navTo && (
            <NextLink href={navTo}>
              <Button>{buttonText}</Button>
            </NextLink>
          )}
        </VStack>
      </Center>
    </Card>
  );
};
